type BetterAuthError = {
  code?: string;
  message?: string;
};

const errorMessages: Record<string, string> = {
  EMAIL_NOT_VERIFIED: "Verify your email before logging in.",
  FAILED_TO_CREATE_USER: "We could not create the account. Try again.",
  FAILED_TO_CREATE_SESSION: "Your account is ready, but sign-in failed. Try logging in.",
  INVALID_EMAIL: "Enter a valid email address.",
  INVALID_EMAIL_OR_PASSWORD: "The email or password is incorrect.",
  INVALID_PASSWORD: "The email or password is incorrect.",
  INVALID_TOKEN: "This link is invalid or has expired.",
  PASSWORD_TOO_LONG: "Keep the password under 128 characters.",
  PASSWORD_TOO_SHORT: "Use at least 10 characters.",
  TOO_MANY_REQUESTS: "Too many attempts. Wait a moment and try again.",
  USER_ALREADY_EXISTS: "An account already exists for this email.",
  USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL:
    "An account already exists for this email.",
};

export const getAuthErrorMessage = (
  error: BetterAuthError | null | undefined,
  fallback: string,
): string => {
  if (!error) return fallback;
  const configuredMessage = error.code
    ? errorMessages[error.code]
    : undefined;
  if (configuredMessage) {
    return configuredMessage;
  }

  return error.message?.trim() || fallback;
};
